import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import { getPerson } from "../../store/actions";
import CardInfoField from "../../../../../ui/CardInfoField";
import Avatar from "./Avatar";
import {AccountBadge} from "../AccountBadge";
import CardOrganization from "../../../../../ui/CardOrganization";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "../../../../../ui/Button";
import Progress from "../../../../../ui/Progress";
import RoleSymbol from "../../../../../ui/RoleSymbol";
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Chips from "../../../../../ui/Chips";

const drawerWidth = 280;

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  hide: {
    display: "none"
  },
  typo: {
    fontSize: 16,
    lineHeight: "24px"
  },
  block: {
    marginTop: 16
  },
  devider: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "1px dashed #CACCD1"
  },
  more: {
    marginTop: 24,
    marginBottom: 80,
    display: "flex",
    justifyContent: "center"
  },
  cardTitle: {
    padding: "8px 0",
    borderBottom: "1px dashed #CACCD1"
  },
  rolesBlock:{
    textAlign: "left",
    position: "absolute",
    display: "inline-block",
    height: 20,
    width: "auto",
    alignItems: "flex-start",
  },
  accountBlock:{
    textAlign: "right",
    position: "absolute",
    display: "inline-block",
    height: 20,
    width: "auto"
  },
  stateBlock: {
    marginTop: 16,
    marginBottom: 8,
    height: 20,
    display: "flex",
    flexDirection: "column",
    width: "220px",
    boxSizing: "border-box"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000,
    /*[theme.breakpoints.down("md")]: {
      position: "fixed"
    }*/
  },
  drawerClosed: {
    width: 0
  },
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
    top: 65
  },
  drawerPaperContent: {
    boxSizing: "border-box",
    padding: 20
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0
  },
  closeButton: {
    position: 'absolute',
    opacity: 0.5,
    height: 24,
    'text-align': 'left',
    display: "flex",
    alignItems: "flex-start",
    '& .MuiIconButton-root':{
      padding: 0
    }
}
}));

const PersonDrawer = ({
  open,
  getPerson,
  personId,
  personCard,
  history,
  hideLink,
  handleDrawerClose
}) => {
  const classes = useStyles();
  const [card, setCard] = React.useState(null);

  React.useEffect(() => {
    if (personId !== -1) {
      setCard(null);
      getPerson(personId);
    }
  }, [personId]);

  React.useEffect(() => {
    setCard(personCard);
  }, [personCard]);

  const onLinkClick = () => {
    history.push(`/work/app/person/${card.id}`);
  };

  return (
    <Drawer
      className={open ? classes.drawerOpen : classes.drawerClosed}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <div>
        {!hideLink && <div className={classes.closeButton}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronRightIcon/>
          </IconButton>
        </div>}
      {card ? (
        <div className={classes.drawerPaperContent}>
          <Avatar fileId={card.avatar} />
          <div className={classes.cardTitle}>
            <Typography className={classes.typo} align="center">
              {`${card.lastName} ${card.firstName} ${card.middleName ? card.middleName : ""}`}
            </Typography>
          </div>

{((card.roles && card.roles.length>0) || (card.accounts && card.accounts.length>0)) &&
          <><div className={classes.stateBlock}>
            <Grid container direction="row" justify="space-between" alignItems="center">
              <Grid item xs={6}>
                {(card.roles && card.roles.length>0) &&
                <div className={classes.rolesBlock}>
                    {card.roles.map(({ symbol, name }) =><RoleSymbol key={symbol} symbol={symbol} title={name}/>)}
                </div>
              }
              </Grid>
              <Grid item xs={6}>
                {(card.accounts && card.accounts.length>0) &&
                <div className={classes.accountBlock}>
                    {card.accounts.map(({ state, type }) => <AccountBadge state={state} type={type}/>)}
                </div>
              }
              </Grid>
          </Grid>
          </div>

          <div className={classes.devider}></div></>}

          <CardInfoField field="Город:" value={card.municipalName ? card.municipalName : "-"} />
          <CardInfoField field="Телефон:" value={card.phone ? card.phone : "-"} />
          <CardInfoField field="E-mail:" value={card.email ? card.email : "-"} />
          {((card.skillStates && card.skillStates.length !== 0) ||
          (card.worldSkills && card.worldSkills.length !== 0)) && (
              <>
                <div className={classes.devider}></div>
                <div className={classes.block}>
                  <Typography style={{ display: 'block', marginBottom: '8px'}}
                    variant="caption"
                    color="textSecondary">
                    Навыки и компетенции
                  </Typography>
                    <Chips largeWS={true} specialities={card.skillStates} worldSkills={card.worldSkills} ellipsis={true}/>
                </div>
              </>
          )}

          {(card.organizations && card.organizations.length !== 0) && <>
          <div className={classes.devider}></div>
          <div className={classes.block}>
            <Typography style={{ display: 'block', marginBottom: '8px'}}
              variant="caption"
              color="textSecondary">
              Организации
            </Typography>
            <div style={{ display: 'block'}}>
              {card.organizations.map(({ id, orgName, logo }) =>
              <CardOrganization key={`organization${id}`} orgName={orgName} logo={logo}/>)}
            </div>
          </div></>}

          <div className={classes.devider}></div>

          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
        </div>
      ) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
      </div>
    </Drawer>
  );
};

const mapStateToProps = state => ({
  personCard: state.persons ? state.persons.personCard : {}
});

const mapDispatchToProps = dispatch => ({
  getPerson: id => dispatch(getPerson(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PersonDrawer));
